import { FC } from 'react';

interface CalendarProps {}

const CardIcon: FC<CalendarProps> = (props: CalendarProps) => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M2.5 19.5V4.5H21.5V19.5H2.5ZM3.99998 8.40385H20V5.99997H3.99998V8.40385ZM3.99998 11.5961V18H20V11.5961H3.99998Z'
                fill='black'
            />
        </svg>
    );
};

export default CardIcon;
